import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ThemeModule } from '../shared/theme/theme.module';
import { AuthHeaderComponent } from './components/auth-header/auth-header.component';
import { AnimatedBackgroundComponent } from './components/background/animated/animated-background.component';
import { InvestigatorsBackgroundEffectComponent } from './components/background/animated/investigators/investigators-background-effect.component';
import { VideoBackgroundComponent } from './components/background/video-background/video-background.component';
import { GameLogoComponent } from './components/game-logo/game-logo.component';
import { PublicDefaultMenuComponent } from './components/public-layout/public-default-menu/public-default-menu.component';
import { PublicLayoutComponent } from './components/public-layout/public-layout.component';
import { LoadCustomThemeDirective } from './directives/load-custom-theme.directive';
import { ResizeFontToFitDirective } from './directives/resize-font-to-fit.directive';
import { ResizeRotatedFontToFitDirective } from './directives/resize-rotated-font-to-fit.directive';
import { UpdateSectionDirective } from './directives/update-section.directive';

@NgModule({
  declarations: [
    PublicLayoutComponent,
    PublicDefaultMenuComponent,
    AnimatedBackgroundComponent,
    InvestigatorsBackgroundEffectComponent,
    VideoBackgroundComponent,
    GameLogoComponent,
    AuthHeaderComponent,
    UpdateSectionDirective,
    ResizeFontToFitDirective,
    ResizeRotatedFontToFitDirective,
    LoadCustomThemeDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ThemeModule,
  ],
  exports: [
    AnimatedBackgroundComponent,
    VideoBackgroundComponent,
    GameLogoComponent,
    AuthHeaderComponent,
    UpdateSectionDirective,
    ResizeFontToFitDirective,
    ResizeRotatedFontToFitDirective,
    LoadCustomThemeDirective,
  ],
})
export class LayoutModule {
}
